import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useMsal } from "@azure/msal-react";
import { Box, List, ListItem, Modal, Popover, TextField, Typography, Button, Alert } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { DataGrid } from "@mui/x-data-grid";
import { format, parse } from "date-fns";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchLauchMailresponse, updateCurrentStatus, updateProgramNameInMailer } from "../Redux/Approver";
import ApproverMailGeneration from "./ApproverMailGeneration";
import ChooseDesigner from "./ChooseDesigner";
import "./NewTable.css";
import "./CommunicationsTable.css";
import axios from "axios";
import { baseURL } from "../Constant";
import ApprovedTemplate from "../E-CertificateComponent/ApprovedTemplate";
const CustomFooter = () => <div></div>;
const pastPhase1Threshold = approvedDate => {
  if (!approvedDate) return false;
  const phase2StartDate = new Date("2025-07-09"); // Deployed designer workflow to prod on this date
  // Parse approvedDate in "DD-MM-YYYY" format
  const [day, month, year] = approvedDate?.split("-");
  const date = new Date(Number(year), Number(month) - 1, Number(day)); // Ensure numeric input
  return date >= phase2StartDate;
};
const CommunicationsTable = ({
  setL2
}) => {
  const [openDate, setOpenDate] = useState(false);
  const [statusName, setStatusName] = useState("Waiting for Approval");
  const [searchedText, setSearchedText] = useState("");
  const [selectedMail, setSelectedMail] = useState("");
  const [initialRows, setInitialRows] = useState([]);
  const [uniqueID, setUniqueID] = useState("");
  const [rows, setRows] = useState(initialRows);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElDate, setAnchorElDate] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentColumn, setCurrentColumn] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const [status, setStatus] = useState();
  const [userQuery, setUserQuery] = useState("");
  const [activeScreen, setActiveScreen] = useState("default");
  const [startDate, setDate] = React.useState(new Date());
  const [createdDate, setCreatedDate] = useState("");
  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const [program, setProgram] = useState("");
  const [type, setType] = useState("");
  const launchMails = useSelector(state => state.approver.launchMails);
  const [sendArrDate, setSendArrDate] = useState(false);
  const [sortModel, setSortModel] = useState([{
    field: "senddatetime",
    sort: "desc"
  }]);
  const [sortModelNew, setSortModelNew] = useState([]);
  const [activeButton, setActiveButton] = useState(1);
  const [pnEditable, setPNEditable] = useState(false);
  const [newProgramName, setNewProgramName] = useState("initial value");
  const [preparingforDownload, setPreparingforDownload] = useState(false);
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [user, setUser] = useState(null);
  const [secureCertificateUrl, setSecureCertificateUrl] = useState("");
  function triggerDownload(url, fileName) {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // Suggests a filename
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  useEffect(() => {
    if (activeAccount) {
      setUser(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);
  const viewSubmission = async fileName => {
    setPreparingforDownload(true);
    try {
      const response = await axios.get(`${baseURL}/open-ppt-in-onedrive/download`, {
        params: {
          blobname: fileName,
          eid: user
        },
        headers: {
          Authorization: localStorage.getItem('token'),
          "Content-Type": "application/json"
        }
      });
      const {
        downloadLink
      } = response.data;
      if (downloadLink) {
        triggerDownload(downloadLink, fileName);
      } else {
        alert('Could not generate OneDrive link.');
      }
    } catch (err) {
      console.error('Failed to download PPT in OneDrive:', err);
    } finally {
      setPreparingforDownload(false);
    }
  };

  //Choose designer Modal
  const [commId, setCommId] = useState('');
  const [dznStatus, setDznStatus] = useState('');
  const [openAssignDesignerModal, setOpenAssignDesignerModal] = useState(false);
  const [assignedDesigners, setAssignedDesigners] = useState([]);
  const [dznerLoading, setDznerLoading] = useState(false);
  const handleOpenDesignerModal = mailer => {
    setCommId(mailer?.uniqueID);
    setDznStatus(mailer?.fileStatus);
    setAssignedDesigners(mailer?.assignedTo || []);
    setOpenAssignDesignerModal(true);
  };

  // Custom sorting function for date
  const dateSortComparatornew = (v1, v2) => {
    const date1 = moment(v1, "DD-MM-YYYY HH:mm:ss").toDate(); // Parse the date string to Date object
    const date2 = moment(v2, "DD-MM-YYYY HH:mm:ss").toDate(); // Parse the date string to Date object
    return date1 - date2; // Compare timestamps
  };
  const selectDateHandler = d => {
    setDate(d);
    let created_date = moment(d).format("DD-MM-YYYY");
    setCreatedDate(created_date);
    setCurrentColumn("sendDate");
    // handleSelection(created_date, false);
  };
  let approverStatus = {
    "Not Applicable": 0,
    "Waiting for Approval": -1,
    Approved: 1,
    "On hold": 2
  };
  useEffect(() => {
    if (currentColumn == "sendDate") {
      handleSelection(createdDate, false);
    }
  }, [currentColumn, startDate]);
  const dispatch = useDispatch();
  const handleFilterClick = (event, column) => {
    setCurrentColumn(column);
    setAnchorEl(event.currentTarget);
    if (column === "isApproved") {
      filteredOptions = ["Approved", "Waiting for Approval", "Not Applicable", "All"];
    } else {
      filteredOptions = Array.from(new Set(launchMails?.map(row => row[column]))).filter(value => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()));
    }
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
    setCurrentColumn(null);
    setSearchTerm("");
  };
  const handlePNSubmit = (e, recordId) => {
    e.preventDefault();
    if (!recordId) {
      console.error("No record ID provided!");
      return;
    }
    const formData = new FormData(e.target);
    const newProgramName = formData.get("newProgramName")?.trim();
    if (!newProgramName) {
      console.warn("Program name cannot be empty.");
      return;
    }
    dispatch(updateProgramNameInMailer({
      newname: newProgramName,
      uniqueID: recordId
    }));
    setOpenModal(false);
    setPNEditable(false);
    setNewProgramName("");
  };
  const handleSelection = (value, isSelected) => {
    let newSelectedFilters = {
      ...selectedFilters
    };
    if (currentColumn === "isApproved") {
      if (value === "All") {
        newSelectedFilters[currentColumn] = [1, -1, 0];
      } else {
        const mappedValue = value === "Approved" ? 1 : value === "Waiting for Approval" ? -1 : value === "Not Applicable" ? 0 : null;
        if (mappedValue !== null) {
          if (!newSelectedFilters[currentColumn]) {
            newSelectedFilters[currentColumn] = [mappedValue];
          } else if (isSelected) {
            newSelectedFilters[currentColumn] = newSelectedFilters[currentColumn].filter(item => item !== mappedValue);
          } else {
            newSelectedFilters[currentColumn] = [...newSelectedFilters[currentColumn], mappedValue];
          }
        }
      }
    } else if (currentColumn === "sendDate") {
      newSelectedFilters[currentColumn] = [value];
    } else {
      if (!newSelectedFilters[currentColumn]) {
        newSelectedFilters[currentColumn] = [value];
      } else if (isSelected) {
        newSelectedFilters[currentColumn] = newSelectedFilters[currentColumn].filter(item => item !== value);
      } else {
        newSelectedFilters[currentColumn] = [...newSelectedFilters[currentColumn], value];
      }
    }
    setSelectedFilters(newSelectedFilters);
    let filteredRows = launchMails;
    Object.keys(newSelectedFilters).forEach(column => {
      if (newSelectedFilters[column]?.length > 0) {
        filteredRows = filteredRows.filter(row => newSelectedFilters[column].includes(row[column]));
      }
    });
    setRows([...filteredRows]?.sort((a, b) => {
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }));
  };
  const handleReset = () => {
    setSelectedFilters({});
    // setRows(launchMails.map((item, sno) => ({ ...item, id: sno + 1 })));
    statusName === "All" ? setRows(launchMails).sort((a, b) => {
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }) : setRows(launchMails.filter(value => {
      return value?.isApproved === approverStatus[statusName];
    }).sort((a, b) => {
      // if (a["sendDate"] < b["sendDate"]) return 1;
      // if (a["sendDate"] > b["sendDate"]) return -1;
      // return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }));
    handleFilterClose();
  };
  const handleOpen = record => {
    setOpenModal(true);
    setModalRecord(record);
  };
  const handleClose = () => {
    setOpenModal(false);
    setPNEditable(false);
  };
  const handleDispalyContent = (value, uniqueID, status, userQuery, program, type, subcategory, secureFileCertificateUrl) => {
    setSelectedMail(value);
    setUniqueID(uniqueID);
    setStatus(status);
    dispatch(updateCurrentStatus(status));
    setUserQuery(userQuery);
    subcategory === "Endorsements" && type === "E-Certificate" && secureFileCertificateUrl.split("===")[0] === 'pre-approved' ? setActiveScreen("certificate") : setActiveScreen("contentscreen");
    setSecureCertificateUrl(secureFileCertificateUrl);
    setProgram(program);
    setType(type);
  };
  const handleSort = field => {
    setSortModel(prevSortModel => {
      const existingModel = prevSortModel.find(model => model.field === field);
      const sortDirection = existingModel ? existingModel.sort === "asc" ? "desc" : "asc" : "asc";
      return [{
        field,
        sort: sortDirection
      }];
    });
  };
  const parseDate = dateString => {
    const [day, month, year] = dateString?.split("-").map(Number);
    return new Date(year + 2000, month - 1, day);
  };
  const formatDate = dateString => {
    const [day, month, year] = dateString.split("-").map(Number);
    return format(new Date(year + 2000, month - 1, day), "dd-MM-yy");
  };

  // function parseDateAgain(dateString){
  //   const date = new Date(dateString);

  // // Format the Date object into 'dd-mm-yyyy'
  // return format(date, 'dd-MM-yyyy');
  // }

  const parseDateAgain = dateString => {
    return parse(dateString, "dd-MM-yyyy", new Date());
  };

  // Custom sorting function for date
  const dateSortComparator = (v1, v2) => {
    const date1 = parseDateAgain(v1);
    const date2 = parseDateAgain(v2);
    return date1.getTime() - date2.getTime(); // Compare timestamps
  };
  const formatDateAgain = dateString => {
    const date = parseDateAgain(dateString);
    return format(date, "dd-MM-yyyy");
  };
  const columns = [{
    field: "id",
    headerName: <div className="migrated-style-communicationstable-1b6345-1">SI#</div>,
    minWidth: 70,
    sortable: false,
    flex: 1,
    renderCell: params => params.api.getSortedRowIds().indexOf(params.id) + 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "subcategory",
    headerName: <div className="migrated-style-communicationstable-1b6345-2">
     Content
     <div>
      <FilterAltIcon onClick={e => handleFilterClick(e, "subcategory")} className="migrated-style-communicationstable-1b6345-3" />
     </div>
    </div>,
    minWidth: 120,
    sortable: false,
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "mailtype",
    headerName: <div className="migrated-style-communicationstable-1b6345-4">
     Sub-Type
     <FilterAltIcon onClick={e => handleFilterClick(e, "mailtype")} className="migrated-style-communicationstable-1b6345-5" />
    </div>,
    minWidth: 100,
    sortable: false,
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "programname",
    headerName: <div className="migrated-style-communicationstable-1b6345-6">
     Program Name
     <SearchIcon onClick={e => handleFilterClick(e, "programname")} className="migrated-style-communicationstable-1b6345-7" />
    </div>,
    minWidth: 180,
    sortable: true,
    //  renderHeader: (params) => (
    //   <CustomHeader
    //    colDef={params.colDef}
    //    onSortClick={handleSort}
    //    sortDirection={
    //     sortModel.find((model) => model.field === "programname")?.sort || null
    //    }
    //   />
    //  ),
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "contentlink",
    sortable: false,
    headerName: <div className="migrated-style-communicationstable-1b6345-8">
     Review Content
    </div>,
    minWidth: 130,
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell",
    // Center-align cell values
    renderCell: params => <p onClick={() => {
      handleDispalyContent(params.row.template, params.row.uniqueID, params.row.isApproved, params.row.userQuery, params.row.programname, params.row.mailtype, params.row.subcategory, params.row.secureCertificateUrl);
      setL2(params.row.programname); //tentative
    }} className="migrated-style-communicationstable-1b6345-9">
     Review Content
    </p>
  }, {
    field: "senddatetime",
    headerName: <div className="migrated-style-communicationstable-1b6345-10">
     Date & Time Created
     <CalendarMonthIcon
      // onClick={(e) => handleFilterClick(e, "sendDate")}
      onClick={e => {
        const sendDateArr = rows.map(obj => moment(obj.sendDate, "DD/MM/YYYY").toDate());
        setSendArrDate(sendDateArr);
        setOpenDate(true);
        setAnchorElDate(e.currentTarget);
      }} className="migrated-style-communicationstable-1b6345-11" />
    </div>,
    minWidth: 200,
    //  valueGetter: (params) => params,
    //  renderCell: (params) => formatDateAgain(params.row.sendDate),
    //  sortComparator: dateSortComparator,
    sortable: true,
    sortComparator: dateSortComparatornew,
    // Use the custom sorting function
    //  renderHeader: (params) => (
    //   <CustomDateHeader
    //    colDef={params.colDef}
    //    sortModel={sortModel}
    //    onSortModelChange={(newModel) => setSortModel(newModel)}
    //   />
    //  ),
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "user",
    headerName: <div className="migrated-style-communicationstable-1b6345-12">
     Requestor Id
     <FilterAltIcon onClick={e => handleFilterClick(e, "user")} className="migrated-style-communicationstable-1b6345-13" />
    </div>,
    minWidth: 180,
    sortable: true,
    flex: 1,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "isApproved",
    headerName: <div className="migrated-style-communicationstable-1b6345-14">
     Status
     <FilterAltIcon onClick={e => handleFilterClick(e, "isApproved")} className="migrated-style-communicationstable-1b6345-15" />
    </div>,
    minWidth: 150,
    sortable: false,
    flex: 1,
    headerClassName: "center-header",
    cellClassName: "left-cell",
    renderCell: params => <p>
     {params.row.isApproved === 1 ? "Approved" : params.row.isApproved === 0 ? "Not Applicable" : params.row.isApproved === -1 ? "Waiting for Approval" : "On Hold"}
    </p>
  }, {
    field: "fileStatus",
    headerName: <div className="migrated-style-communicationstable-1b6345-16">
     Designer Status
     <FilterAltIcon onClick={e => handleFilterClick(e, "fileStatus")} className="migrated-style-communicationstable-1b6345-17" />
    </div>,
    minWidth: 150,
    sortable: false,
    flex: 1,
    headerClassName: "center-header",
    cellClassName: "left-cell",
    renderCell: params => <p>
     {params.row.fileStatus || "NA"}
    </p>
  },
  // {
  //  field: "actions",
  //  headerName: (
  //   <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
  //    Actions
  //   </div>
  //  ),
  //  minWidth: 100,
  //  flex: 0.3,
  //  sortable: false,
  //  headerClassName: "center-header", // Center-align header
  //  cellClassName: "left-cell", // Center-align cell values
  //  renderCell: (params) => (
  //   <Button
  //    size="small"
  //    variant="outlined"
  //    disabled= {params.row.isApproved!==1 || !pastPhase1Threshold(params.row.approvedDate) } 
  //    onClick={() => handleOpenDesignerModal(params.row)}
  //    style={{ cursor: "pointer", textTransform:"none", padding:"0px"}}
  //   > {params.row.fileStatus==null || params.row.fileStatus=="Un-assigned"?"Assign":"Re-Assign"}</Button>
  //  ),
  // },
  {
    field: "details",
    headerName: <div className="migrated-style-communicationstable-1b6345-18">
     Details
    </div>,
    minWidth: 100,
    flex: 0.3,
    sortable: false,
    headerClassName: "center-header",
    // Center-align header
    cellClassName: "left-cell",
    // Center-align cell values
    renderCell: params => <img onClick={() => handleOpen(params.row)} src={process.env.PUBLIC_URL + "/Images/desc_icon.png"} className="migrated-style-communicationstable-1b6345-19"></img>
  }];
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  let filteredOptions;
  if (currentColumn == "isApproved") {
    filteredOptions = ["Approved", "Waiting for Approval", "Not Applicable", "All"];
  } else {
    filteredOptions = Array.from(new Set(launchMails?.map(row => row[currentColumn]))).filter(value => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()));
  }

  //  }

  useEffect(() => {
    dispatch(fetchLauchMailresponse());
  }, []);
  const clearFilters = () => {
    setSelectedFilters({});
    setSearchedText("");
    setSortModel([]);
    // setRows(launchMails);

    // setRows(
    //  launchMails
    //   ?.filter((value) => {
    //    return value?.isApproved == -1 || value?.isApproved == 1 || value?.isApproved == 0;
    //   })
    //   .sort((a, b) => {
    //    if (a["sendDate"] < b["sendDate"]) return 1;
    //    if (a["sendDate"] > b["sendDate"]) return -1;
    //    return 0;
    //   })
    // );

    statusName === "All" ? setRows(launchMails) : setRows(launchMails.filter(value => {
      return value?.isApproved === approverStatus[statusName];
    }).sort((a, b) => {
      //  if (a["sendDate"] < b["sendDate"]) return 1;
      //  if (a["sendDate"] > b["sendDate"]) return -1;
      //  return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA; // Sort in descending order
    }));
  };
  const handleColumnReset = () => {};
  useEffect(() => {
    setSelectedFilters({});
    setStatusName("Waiting for Approval");
    setRows(launchMails?.filter(value => {
      return value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.user?.toLowerCase()?.includes(searchedText.toLowerCase());
    })
    // ?.map((item, sno) => ({ ...item, id: sno + 1 }))
    );
  }, [searchedText]);
  useEffect(() => {
    // Apply the initial filters and sort
    if (launchMails?.length > 0) {
      const filteredRows = launchMails.filter(row => row.isApproved === approverStatus["Waiting for Approval"]).sort((a, b) => {
        if (moment(a.sendDate, "DD/MM/YYYY").isBefore(moment(b.sendDate, "DD/MM/YYYY"))) return 1;
        if (moment(a.sendDate, "DD/MM/YYYY").isAfter(moment(b.sendDate, "DD/MM/YYYY"))) return -1;
        return 0;
      });
      setRows(filteredRows);
      setSelectedFilters({
        isApproved: [-1]
      }); // Filter for "Waiting for Approval"
    }
  }, [launchMails]);
  let rowsWithSerial = rows.map((row, index) => ({
    ...row,
    id: index + 1
  }));
  return <>
   {activeScreen == "default" && <>
      {preparingforDownload && <Alert severity="info" sx={{
        mb: 2
      }}>
          Preparing for the download. Please wait
        </Alert>}
     <div className="btns-container">
      <span className="clear-filter" onClick={clearFilters}>
       Clear Filter
      </span>
     </div>

     <div className="datagrid-container migrated-style-communicationstable-1b6345-20">
      <DataGrid rows={rowsWithSerial} columns={columns} pageSize={pageSize} sortModel={sortModel} onSortModelChange={newModel => setSortModel(newModel)} onFilterModelChange={handleSelection} initialState={{
          pagination: {
            paginationModel: {
              pageSize: 7
            }
          }
        }} pageSizeOptions={[7, 10, 25]} disableColumnMenu // This removes the three dots menu
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#022278",
            // Customize the header background color
            color: "white",
            // Customize text color
            padding: "0px !important"
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            textAlign: "left"
          },
          "& .MuiDataGrid-root": {
            width: "100%" // Ensure DataGrid spans the full width
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#fff" // Customize the sorter (sort icon) color
          },
          "& .MuiDataGrid-columnHeader": {
            position: "sticky",
            top: 0,
            backgroundColor: "#022278",
            // Optional: to ensure it’s visible on scroll
            color: "#fff"
          },
          "& .MuiDataGrid-columnHeaders": {
            width: "var(--DataGrid-rowWidth)"
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "white",
            width: "calc(100% - 2px)"
          }
        }} components={{
          Footer: CustomFooter // Replace default footer with your custom component
        }} />
      <Modal hideBackdrop open={openModal} onClose={handleClose} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
       <Box className="model">
        <div className="model_heading">
         <h5 className="paramodel">Details</h5>
         <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
          Close
         </span>
        </div>
        <hr />
        <div className="program-modal-details">
         <div className="program-details-wrap">
          <p className="program-details-header">Category: </p>
          <p className="program-details-value">{modalRecord?.category}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Type: </p>
          <p className="program-details-value">{modalRecord?.subcategory}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Program Name:
            {modalRecord?.campaignId === 0 && <button onClick={() => {
                    setPNEditable(true);
                    setNewProgramName(modalRecord?.programname);
                  }} className="migrated-style-communicationstable-1b6345-21">
              <ModeEditOutlineOutlinedIcon className="migrated-style-communicationstable-1b6345-22" />               
              </button>}
          </p>
          {pnEditable ? <form onSubmit={e => handlePNSubmit(e, modalRecord?.uniqueID)}>
            <input name="newProgramName" type="text" value={newProgramName} onChange={e => setNewProgramName(e.target.value)} placeholder="Enter new name here..." className="migrated-style-communicationstable-1b6345-23" />
            <button type="submit" className="migrated-style-communicationstable-1b6345-24">
              Save
            </button>
            <button type="button" onClick={() => {
                    setPNEditable(false);
                    setNewProgramName("");
                  }} className="migrated-style-communicationstable-1b6345-25">
              Cancel
              </button>
            </form> : <p className="program-details-value">{modalRecord?.programname}</p>}
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Sub-Type: </p>
          <p className="program-details-value">{modalRecord?.mailtype}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date & Time Created: </p>
          <p className="program-details-value">{modalRecord?.senddatetime}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">On Behalf of: </p>
          <p className="program-details-value migrated-style-communicationstable-1b6345-26">{modalRecord?.onBehalf}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Status: </p>
          <p className="program-details-value">
           {modalRecord?.isApproved == 1 ? "Approved" : modalRecord?.isApproved == 0 ? "Not Applicable" : modalRecord?.isApproved == 2 ? "On Hold" : "Waiting for Approval"}
          </p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date & Time of Approval: </p>
          <p className="program-details-value">{modalRecord?.approveddatetime}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Approved By: </p>
          <p className="">{modalRecord?.approvedby}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Design Assigned By: </p>
          <p className="">{modalRecord?.assignedBy}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Design Assigned To: </p>
          <ul>
          {modalRecord?.assignedTo?.map(designer => <li className="" key={designer.eid}>
              {designer.submittedppt ? <Button disabled={preparingforDownload} sx={{
                      textDecoration: "underline",
                      textTransform: "none",
                      color: "blue",
                      padding: "0px"
                    }} onClick={() => viewSubmission(designer.submittedppt)}>{designer.eid}</Button> : designer.eid}
              </li>)}
          </ul>
         </div>
        </div>
       </Box>
      </Modal>
      
     
      <ChooseDesigner openAssignDesignerModal={openAssignDesignerModal} setOpenAssignDesignerModal={setOpenAssignDesignerModal} assignedDesigners={assignedDesigners} setAssignedDesigners={setAssignedDesigners} loading={dznerLoading} setLoading={setDznerLoading} commId={commId} fileStatus={dznStatus} />

      <Popover open={openDate} onClose={() => setOpenDate(false)} anchorEl={anchorElDate} anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }} className="pop-date">
       <div className="date-container">
        <DatePicker open={openDate} dateFormat="yyyy/MM/dd"
            //  includeDates={sendArrDate}
            onChange={e => {
              selectDateHandler(e);
              setOpenDate(false);
            }} />
       </div>
      </Popover>
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleFilterClose} anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }} PaperProps={{
          style: {
            maxHeight: 300,
            // Set your desired height here
            maxWidth: 250,
            overflow: "auto",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 10,
            paddingBottom: 10
          }
        }}>
       <Box sx={{
            p: 0
          }}>
        <TextField fullWidth placeholder="Search..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} sx={{
              "& .MuiInputBase-input": {
                fontSize: "0.7rem",
                // Change the font size as needed
                padding: "3.5px 6px",
                textTransform: "capitalize"
              }
            }} />
        <List>
         {filteredOptions.map((option, index) => {
                const isSelected = selectedFilters[currentColumn]?.includes(option === "Approved" ? 1 : option === "Waiting for Approval" ? -1 : option === "Not Applicable" ? 0 : option);
                return <ListItem button key={index} onClick={() => handleSelection(option, isSelected)} sx={{
                  padding: "0px",
                  // Adjust padding as needed
                  height: "22px"
                }}>
            <ListItemIcon className="migrated-style-communicationstable-1b6345-27">
             {isSelected ? <CheckBoxIcon sx={{
                      width: "0.6em",
                      height: "0.6em",
                      "& path": {
                        fill: "#1976d2" // Customize the fill color of the SVG path
                      }
                    }} /> : <CheckBoxOutlineBlankIcon sx={{
                      width: "0.6em",
                      height: "0.6em"
                    }} />}
            </ListItemIcon>
            <ListItemText primary={option} primaryTypographyProps={{
                    style: {
                      fontSize: "0.8rem"
                    }
                  }} />
           </ListItem>;
              })}
        </List>
        <Typography onClick={() => {
              handleReset();
            }} className="migrated-style-communicationstable-1b6345-28">
         Reset
        </Typography>
       </Box>
      </Popover>
     </div>
    </>}

   {activeScreen != "default" && activeScreen !== "certificate" && <>
     <ApproverMailGeneration setL2={setL2} selectedMail={selectedMail} setSelectedMail={setSelectedMail} uniqueID={uniqueID} setActiveScreen={setActiveScreen} status={status} userData={userQuery} program={program} type={type} />
    </>}
   {activeScreen === "certificate" && <ApprovedTemplate outputFileName={secureCertificateUrl} backButton={'enabled'} setActiveScreen={setActiveScreen} setL2={setL2} />}
  </>;
};
export default CommunicationsTable;
